import { ProductExtra, ProductOrder } from '@interfaces/OrderTypes';
import { formatToCurrency } from '@utils/formats';
import { PosPrintTableField } from '@plick/electron-pos-printer';
import { consolidateProducts } from '@utils/print/consolidateProducts';
import { productLabel } from '@utils/print/productLabel';

const getExtras = (extras: ProductExtra[]) => {
  const data: PosPrintTableField[][] = extras.map((extra) => {
    // P0-A.2: extra a $0 (o precio no numérico) conserva la línea pero con la celda de
    // precio VACÍA. Un precio negativo (descuento de línea) sí se imprime.
    const price = Number(extra.precio);
    const showPrice = Number.isFinite(price) && price !== 0;
    return [
      {
        type: 'text',
        value: `${extra.cantidad} x ${extra.nombre}`,
        style: { textAlign: 'left', paddingLeft: '16px' },
      },
      {
        type: 'text',
        value: showPrice ? formatToCurrency(extra.precio) : '',
      },
    ];
  });

  return data;
};

export const getOrderProducts = (products: ProductOrder[]) => {
  // P0-A.3: consolida líneas idénticas (suma cantidades/subtotales, extras incluidos).
  const data: PosPrintTableField[][] = consolidateProducts(products).flatMap((product) => {
    return [
      [
        {
          type: 'text',
          // P0-A.1: omite ` - {presentacion}` si está vacía o es igual al nombre.
          value: productLabel(product),
          style: { textAlign: 'left', paddingRight: '5px', paddingTop: '4px' },
        },
        {
          type: 'text',
          value: formatToCurrency(product.subtotal),
          style: { paddingTop: '4px' },
        },
      ],
      product?.instrucciones
        ? [
            {
              type: 'text',
              value: product.instrucciones,
              style: { textAlign: 'left', fontWeight: '700' },
            },
          ]
        : [],
      ...getExtras(product.extras),
      [
        {
          type: 'divider',
          style: {
            paddingTop: '4px',
          },
        },
      ],
    ];
  });

  return data;
};
